import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { applyAccentHue, readAccentHue } from "./lib/accent";
import "./index.css";

applyAccentHue(readAccentHue());

async function startApp() {
  if (import.meta.env.VITE_MOCK === "true") {
    // mocks/ is excluded from typecheck; use a variable so tsc skips this import.
    const mocksEntry = "./mocks/browser";
    const { worker } = await import(/* @vite-ignore */ mocksEntry);
    await worker.start({ onUnhandledRequest: "bypass" });
  }

  // biome-ignore lint/style/noNonNullAssertion: root element always exists
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

startApp();
